/**
 * Build GET query params for station schedule list endpoints.
 * Matches backend schedule_date_filter: `date` overrides start_date/end_date.
 */
export interface ScheduleDateQueryParams {
  date?: string
  start_date?: string
  end_date?: string
}

export function buildScheduleDateQueryParams(
  start?: string | null,
  end?: string | null,
): ScheduleDateQueryParams {
  const s = (start || "").trim()
  const e = (end || "").trim()
  if (s && e && s === e) {
    return { date: s }
  }
  const out: ScheduleDateQueryParams = {}
  if (s) out.start_date = s
  if (e) out.end_date = e
  return out
}
